const SITE_URL = "https://hoobuy.tattoo";

interface SchemaOrgProps {
  type: "WebSite" | "Article" | "BreadcrumbList";
  data: Record<string, unknown>;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  const schema = { "@context": "https://schema.org", "@type": type, ...data };
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

export interface ArticleSchemaData {
  headline: string;
  description: string;
  image: string;
  datePublished: string;
  dateModified: string;
  url: string;
  authorName?: string;
}

export function buildArticleSchema(d: ArticleSchemaData) {
  return {
    headline: d.headline,
    description: d.description,
    image: d.image,
    datePublished: d.datePublished,
    dateModified: d.dateModified,
    url: d.url,
    author: {
      "@type": "Organization",
      name: d.authorName || "Hoobuy Spreadsheet",
    },
    publisher: {
      "@type": "Organization",
      name: "Hoobuy Spreadsheet",
      logo: {
        "@type": "ImageObject",
        url: "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/879fae149d7d175a673508cd1be74143.jpeg",
      },
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": d.url,
    },
  };
}

export function buildWebSiteSchema() {
  return {
    name: "Hoobuy Spreadsheet Atualizado",
    url: SITE_URL,
    description:
      "Hoobuy Spreadsheet Atualizado 2026 — Encontre produtos verificados, organizados em planilhas inteligentes com links seguros para compras na China. Acesso rápido e economia garantida.",
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: `${SITE_URL}/search?q={search_term_string}`,
      },
      "query-input": "required name=search_term_string",
    },
  };
}